import React from "react";
import { styles } from "../annonceDetaille";
import { Col, Row } from "reactstrap";
import { FaCheckSquare, FaSquare } from "react-icons/fa";

function CheckboxAvanBen({ avantages, setAvantages }) {
  const toggle = (i) => {
    setAvantages((prev) =>
      prev.map((av, idx) => (idx === i ? { ...av, checked: !av.checked } : av))
    );
  };

  return (
    <Row>
      {avantages.map((av, i) => (
        <Col
          md={6}
          key={i}
          className="d-flex align-items-center mb-2"
          onClick={() => toggle(i)}
          style={{ cursor: "pointer" }}
        >
          {av.checked ? (
            <FaCheckSquare className="me-2" />
          ) : (
            <FaSquare className="me-2" />
          )}
          {av.label}
        </Col>
      ))}
    </Row>
  );
}

export default CheckboxAvanBen;
